import { t } from '../../../shared/i18n';
export function buildUserSiteSslPayload(values, certificates = []) {
    if (!values?.ssl_enabled) {
        return { ssl: null };
    }

    const basePayload = {
        enabled: true,
        force_https: values.force_https ?? true,
        hsts: values.hsts ?? false,
    };

    if (values.ssl_mode === 'existing') {
        if (!values.host_ssl_cert_id) {
            return { error: t('Select the SSL certificate to use') };
        }

        const cert = certificates.find((item) => item.id === values.host_ssl_cert_id);
        if (!cert) {
            return { error: t('The selected SSL certificate was not found. Please refresh and try again.') };
        }

        if (!cert.cert_path || !cert.key_path) {
            return { error: t('The certificate file path is incomplete. Please upload or sync the certificate again') };
        }

        return {
            ssl: {
                ...basePayload,
                certificate: cert.cert_path,
                key: cert.key_path,
            },
        };
    }

    if (values.ssl_mode === 'custom') {
        if (!values.custom_ssl_config) {
            return { error: t('Enter a custom SSL configuration') };
        }

        try {
            const parsed = JSON.parse(values.custom_ssl_config);
            return {
                ssl: {
                    ...basePayload,
                    ...parsed,
                },
            };
        } catch (error) {
            return { error: t('Unable to parse SSL configuration JSON. Please check the format.') };
        }
    }

    return { error: t('Select an SSL configuration method') };
}
